<template>
  <div class="row">
    <div class="col-lg-2 p-0 bg-cx2">
      <status-menu :statuses="statuses" @select-status="onSelectStatus" @refresh="onOrdersUpdated"></status-menu>
    </div>
    <div class="col-lg-10 p-0 bg-white order-list">
      <orders-list        
        :orders="orders"
        :selected-status="selectedStatus"
        @select-order="onSelectOrder"
        @orders-updated="onOrdersUpdated"
      >
      </orders-list>
    </div>
  </div>
</template>

<script>
import api from '@/api.js'
import store from '@/stores/special-order.js'
import countBy from 'lodash/countBy'
import StatusMenu from '@/components/special-orders/StatusMenu.vue'
import OrdersList from '@/components/special-orders/OrdersList.vue'
// import OrderDetail from '@/components/special-orders/OrderDetail.vue'
import find from 'lodash/find'

export default {

  components: {
    StatusMenu,
    OrdersList,
    // OrderDetail
  },
 
  data() {
    return {
    }
  },

  created: function() {
    api.get('/special-orders').then(res => {
      store.setOrders(res.data.orders)
    })

    api.get('/special-orders/statuses').then(res => {
      store.setStatuses(res.data.statuses)
    })
  },

  computed: {
    orders() {
      if(!this.selectedStatus.id) {
        return store.state.orders
      }

      return store.state.orders.filter((order) => {
        if(order.status.id == this.selectedStatus.id) {
          return true
        }
      })
    },

    order() {
      return find(store.state.orders, { id: parseInt(this.$route.params.id) }) || {}
    },

    selectedStatus() {
      return find(store.state.statuses, { slug: this.$route.params.status }) || {}
    },

    statuses() {
      const counts = countBy(store.state.orders, 'status_id')
      
      return store.state.statuses.map(status => {
        status.ct = counts[status.id]
        status.active = status.id == this.selectedStatus.id
        return status
      })
    },
  },

  methods: {
    onOrdersUpdated() {
      api.get('/special-orders').then(res => {
        store.setOrders(res.data.orders)
      })

      api.get('/special-orders/statuses').then(res => {
        store.setStatuses(res.data.statuses)
      })      
    },

    onSelectOrder(order) {
      store.setOrder(order)
    },

    onSelectStatus(status) {
      this.selectedStatus = status
      this.onSelectOrder({})
    }
  },
}

</script>

<style scoped>
.order-list {
  height: calc(100vh - 48px);
  overflow-y: auto;
}

</style>